import { FC, useEffect } from "react";
import { useAtomValue } from "jotai";
import { RouterProvider } from "react-router-dom";
import { applicationRoutes } from "../../common/applicationRoutes";
import { currentUser } from "../../state/auth";
import { getLocalPreferences } from "../../state/preferences";

/**
 * The application router component, responsible for:
 * - exposing routes
 * - redirecting users to the last visited URL after they hit browsers' reload button
 */
const AppRouter: FC = () => {
	// Get the current user from the authentication state
	// User need to be defined to redirect to the last visited URL
	const user = useAtomValue(currentUser);

	useEffect(() => {
		const { lastVisitedUrl } = getLocalPreferences();
		if (user && lastVisitedUrl && window.location.pathname !== lastVisitedUrl) {
			window.location.pathname = lastVisitedUrl;
		}
	}, []);

	return <RouterProvider router={applicationRoutes} />;
};

export default AppRouter;
